import Dropzone from 'react-dropzone'

import {
  Box,
  Button,
  Divider,
  Icon,
  Text,
  TextSpinner,
} from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { InfoComponent } from './InfoComponent'

interface ImportModalProps {
  onClose: () => void
  onSubmit: () => void
  download: () => void
  onDropFile: (files: File[]) => void
  fileName?: string
  disabled: boolean
  loading: boolean
  loadingMessage: string
  infoFileMessage: string[]
  infoFileMessageColor: 'destructive' | 'positive' | 'info'
  showInfo: boolean
  title: string
  description: string
}

export const ImportModal = ({
  onClose,
  onSubmit,
  download,
  onDropFile,
  fileName,
  disabled,
  loading,
  loadingMessage,
  infoFileMessage,
  infoFileMessageColor,
  showInfo,
  title,
  description,
}: ImportModalProps) => (
  <Modal
    illustration="upload"
    title={title}
    description={description}
    onClose={onClose}
    onSubmit={onSubmit}
    footer={
      <>
        <Button type="secondary" onClick={onClose}>
          {i18n.t('common.cancel')}
        </Button>
        <Button disabled={disabled} submit>
          {i18n.t('common.start_import')}
        </Button>
      </>
    }
  >
    {loading ? (
      <TextSpinner text={loadingMessage} />
    ) : (
      <Box gap="s4">
        <Box gap="s24">
          <Button iconName="download" onClick={download} type="secondary">
            {i18n.t('common.download_template')}
          </Button>
          <Divider />
          <Box flexDirection="column" gap={'s4'}>
            <Text.Normal weight="medium" size="200">
              {i18n.t('common.upload_document')}
            </Text.Normal>
            <Dropzone
              onDrop={onDropFile}
              multiple={false}
              accept={{
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
              }}
            >
              {({ getRootProps, getInputProps, isDragActive }) => (
                <div {...getRootProps()}>
                  <Box
                    background={isDragActive ? 'viridian100' : 'grey000White'}
                    padding="s32"
                    cursor="pointer"
                    flexDirection="column"
                    alignItems="center"
                    borderRadius={{ all: 'abs012' }}
                    border={{
                      all: {
                        width: 's2',
                        style: 'dashed',
                        color: 'grey400',
                      },
                    }}
                  >
                    <input data-testid="dropzone-input" {...getInputProps()} />
                    <Box textAlign="center">
                      {fileName ? (
                        <Box alignItems="center" gap="s12">
                          <Icon.Large icon="document-edit" />
                          <Text.Normal>{fileName}</Text.Normal>
                        </Box>
                      ) : (
                        <Box alignItems="center">
                          <Box paddingBottom="s6">
                            <Icon.Medium icon="paperclip" />
                          </Box>
                          <Text.Normal weight="bold">
                            {i18n.t('common.drag_drop_placeholder')}
                          </Text.Normal>
                          <Text.Normal>{i18n.t('common.only_xlsx_files')}</Text.Normal>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </div>
              )}
            </Dropzone>
          </Box>
        </Box>
        {showInfo && <InfoComponent messages={infoFileMessage} color={infoFileMessageColor} />}
      </Box>
    )}
  </Modal>
)
